import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    template: `
        <!-- <i class="mi mi-close float-end d-inline dialog-close" mat-dialog-close></i> -->
<h4 mat-dialog-title>
  Comment :
</h4>
<hr>
<mat-dialog-content class="mat-typography">
  <p [innerHTML]="comment | nl2br"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close><span translate>pages.newRetailer.close</span></button>
</mat-dialog-actions>

    
    `,
    styles: [`
  .dialog-close{
    position: relative;
    z-index: 1;
}
.mat-dialog-content{
    overflow-wrap: break-word;
    margin: 30px -24px;
}`]
})
export class ViewCommentComponent implements OnInit {
    comment: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ViewCommentComponent>,) {
        console.log(data)
        this.comment = data;
    }

    ngOnInit(): void {

    }

}
